import style from './style.module.scss';
import {IExpertReview} from 'modules/products/types';
import {Box, Col, Row} from 'components/Grid';
import {Typography} from 'components/Typography';
import Picture from 'components/Picture';
import {getMediaSrc} from 'core/helpers/media';
import {FC} from 'react';

interface IProps {
    expertReview: IExpertReview;
}

const ProductExpertReviewBlock: FC<IProps> = ({expertReview}) => {
    const {comment, imageName, expertName, position} = expertReview;

    return (
        <div className={style.boxWrapper}>
            <Box commonPaddingOnMobileTablet={true}>
                <Row>
                    <Col>
                        <div className={style.review} data-skeleton-item={true}>
                            <Typography className={style.reviewHeader} element={'h2'}>
                                Мнение эксперта
                            </Typography>
                            <div className={style.infoWrapper}>
                                <div className={style.picureWrapper}>
                                    <Picture sources={{}} src={'/images/product-detailed/quotes.webp'} />
                                </div>
                                <div className={style.info}>
                                    <Typography className={style.text} variant={'ch-title-20-reg'}>
                                        {comment}
                                    </Typography>
                                    <div className={style.expert}>
                                        <div className={style.avatar}>
                                            <Picture
                                                sources={{}}
                                                src={getMediaSrc(`/upload/reviews-experts/${imageName}`, {
                                                    isWebp: true,
                                                    width: 56,
                                                })}
                                            />
                                        </div>
                                        <div className={style.expertInfo}>
                                            <Typography element={'div'} variant={'label-16-m'}>
                                                {expertName}
                                            </Typography>
                                            <Typography color={'gray60'} element={'div'} variant={'label-14-r-fluid'}>
                                                {position}
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Box>
        </div>
    );
};

export default ProductExpertReviewBlock;
